import { useMutation, useQuery } from '@tanstack/react-query';
import { OrderDirection } from '../../common/enums/order-direction.enum';
import { ProfileStatus, IProfileCreateDTO } from '../../common/interfaces/profile.interface';
import { addProfile, deleteProfile, getProfiles, updateProfile } from './profile.api';

export const useProfilesQuery = (
  limit: number,
  page: number,
  search?: string,
  orderBy?: string,
  orderDirection?: OrderDirection,
  status?: ProfileStatus,
  companyId?: string,
) => {
  return useQuery({
    queryKey: ['profiles', limit, page, search, orderBy, orderDirection, status, companyId],
    queryFn: () => getProfiles(limit, page, search, orderBy, orderDirection, status, companyId),
  });
};

export const useAddProfileMutation = () => {
  return useMutation({
    mutationKey: ['profile', 'add'],
    mutationFn: (payload: IProfileCreateDTO) => addProfile(payload),
  });
};

export const useUpdateProfileMutation = () => {
  return useMutation({
    mutationKey: ['profile', 'update'],
    mutationFn: (payload: IProfileCreateDTO) => updateProfile(payload),
  });
};

export const useDeleteProfileMutation = () => {
  return useMutation({
    mutationKey: ['profile', 'delete'],
    mutationFn: (id: string) => deleteProfile(id),
  });
};
